import { AdditionalLabelInformationModule } from './features/additional-label-information/additional-label-information.module';
import { NgModule } from '@angular/core';
import { RouterModule, Routes, CanLoad } from '@angular/router';
import { LoginComponent } from './features/login/login.component';
import { ForbiddenComponent } from './features/login/forbidden/forbidden.component';
import { AuthGuard } from './core/guards/auth-guard/auth.guard';
import { DashboardComponent } from './features/dashboard/dashboard.component';
import { LogoutComponent } from './features/logout/logout.component';
import { AdminCountryGuard } from './core/guards/admin-country-guard/admin-country.guard';
import { LoginRedirectingGuard } from './core/guards/login-redirecting-guard/login-redirecting.guard';
import { NotFoundComponent } from './features/login/not-found/not-found.component';

const routes: Routes = [
  {
    path: '',
    redirectTo: '/login',
    pathMatch: 'full',
  },
  {
    path: 'login',
    component: LoginComponent,
  },
  {
    path: 'forbidden',
    component: ForbiddenComponent,
  },
  {
    path: 'not-found',
    component: NotFoundComponent,
  },
  {
    path: 'signout',
    component: LogoutComponent,
  },
  {
    path: 'dashboard',
    canActivate: [LoginRedirectingGuard],
    component: DashboardComponent,
    children: [
      {
        path: 'product-search',
        canLoad: [LoginRedirectingGuard, AuthGuard],
        data: { rights: ['PRINT'] },
        loadChildren: () =>
          import('./features/product-search/product-search.module').then(
            (m) => m.ProductSearchModule
          ),
      },
      {
        path: 'financing-admin',
        canLoad: [LoginRedirectingGuard, AdminCountryGuard],
        canActivateChild: [AdminCountryGuard],
        loadChildren: () =>
          import('./features/financing-admin/financing-admin.module').then(
            (m) => m.FinancingAdminModule
          ),
      },
      {
        path: 'master-data',
        canLoad: [LoginRedirectingGuard],
        loadChildren: () =>
          import('./features/master-data/master-data.module').then(
            (m) => m.MasterDataModule
          ),
      },
      {
        path: 'template-upload',
        canLoad: [LoginRedirectingGuard, AuthGuard],
        data: { rights: ['TEMPLATE'] },
        loadChildren: () =>
          import('./features/template-upload/template-upload.module').then(
            (m) => m.TemplateUploadModule
          ),
      },
      {
        path: 'assign-template',
        canLoad: [LoginRedirectingGuard, AuthGuard],
        data: { rights: ['TEMPLATE'] },
        loadChildren: () =>
          import('./features/assign-template/assign-template.module').then(
            (m) => m.AssignTemplateModule
          ),
      },
      {
        path: 'additional-label-information',
        canLoad: [LoginRedirectingGuard, AuthGuard],
        data: { rights: ['FILE UPLOADER'] },
        loadChildren: () =>
          import(
            './features/additional-label-information/additional-label-information.module'
          ).then((m) => m.AdditionalLabelInformationModule),
      },
    ],
  },
  {
    path: '**',
    component: NotFoundComponent,
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
